import { Link } from 'wouter';
import { useAuthStore } from '../stores/authStore';
import '../styles/LandingPage.css';

const bigwaLogo = '/Landing.png';

export default function LandingPage() {
  const login = useAuthStore((state) => state.login);
  const error = useAuthStore((state) => state.error);

  const handleGoogleSignIn = () => {
    login();
  };

  return (
    <div className="landing-page">
      <div className="landing-content">
        {/* Logo */}
        <div className="landing-logo">
          <img src={bigwaLogo} alt="Bigwa" className="logo-image" />
        </div>

        {/* Título */}
        <h1 className="landing-title">Sua pesquisa em suas mãos</h1>

        {/* Mensagem de confiança */}
        <p className="landing-trust-message">
          🔒 Seus arquivos no seu Google Drive. Sempre.<br />
          Organizados, anotados, seus — com ou sem o Bigwa.
        </p>

        {/* Botões */}
        <div className="landing-buttons">
          <button
            onClick={handleGoogleSignIn}
            className="button button-primary"
          >
            Começar Agora
          </button>
          <button
            onClick={handleGoogleSignIn}
            className="button button-outline"
          >
            Fazer Login
          </button>
        </div>

        {error && <p className="error-message">{error}</p>}

        {/* Bigwa Citação — card de instalação */}
        <div className="citation-card">
          <div className="citation-card-header">
            <img
              src="/icons/bigwa-citation-128.png"
              alt="Bigwa Citação"
              className="citation-card-icon"
            />
            <div className="citation-card-info">
              <span className="citation-card-name">Bigwa Citação</span>
              <span className="citation-card-desc">Para Google Docs</span>
            </div>
          </div>
          <p className="citation-card-text">
            Insira citações ABNT no Google Docs sem sair do documento — direto da sua biblioteca.
          </p>
          <a
            href="https://workspace.google.com/marketplace/app/bigwa_citation/406238159668"
            target="_blank"
            rel="noopener noreferrer"
            className="citation-card-btn"
          >
            Instalar no Google Docs
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M5 12h14M12 5l7 7-7 7"/>
            </svg>
          </a>
          <span className="citation-card-marketplace">Google Workspace Marketplace</span>
        </div>

        {/* Footer Links */}
        <footer className="landing-footer">
          <Link href="/termos" className="landing-footer-link">Termos de Uso</Link>
          <span className="landing-footer-separator">|</span>
          <Link href="/privacidade" className="landing-footer-link">Política de Privacidade</Link>
        </footer>
      </div>
    </div>
  );
}
